import React from 'react';

const ResorcesIntro = () => {
    const sectionData = {
        "heading": "Resources",
        "description": "Get access to the top-notch resources from events hosted on the KonfHub platform. This wealth of information will take your learning to the next level.",
    };

    const { heading, description } = sectionData;

    return (
        <div className="event-section-container abstract-img px-sm-5 px-3">
            <div className='mb- text-center text-lg-start'>
                <h1 className="heading">
                    {heading}
                </h1>
                <p className="description">{description}</p>
            </div>
            <style jsx>{`
          .event-section-container {
            text-align: left;
            padding: 80px 0;
          }
          .abstract-img {
            background-color: white;
            background-image: url('https://d2nnrpx7gk2my2.cloudfront.net/files/670455e0bd1102000878b17a/Abstract3DGridLandscape(1)1.svg');
            background-position: center;
            background-size: cover;
            background-repeat: no-repeat;
            height: 350px;
          }
          .heading {
            font-size: 36px;
            font-weight: 600;
            color: #001234;
            line-height: 44px;
            letter-spacing: 2px;
          }
          .description {
            font-size: 20px;
            font-weight: 400;
            line-height: 30px;
            max-width: 599px;
            color: #525252;
            margin-bottom: 30px;
          }
            @media (max-width: 1000px) {
            .description {
              max-width:100%;
              width:100%;
            }
            }
          @media (max-width: 766px) {
            .heading {
              font-size: 32px;
            }
          }
          @media (max-width: 576px) {
            .abstract-img {
              height: 400px;
            }
          }
        `}</style>
        </div>
    );
};

export default ResorcesIntro;